module.exports = __webpack_public_path__ + "img/neotag_unit_green-01.97c5161e.svg";